(function(){
  'use strict';
  document.documentElement.classList.remove('no-js');

  function qs(root, selector){ return (root || document).querySelector(selector); }
  function qsa(root, selector){ return Array.prototype.slice.call((root || document).querySelectorAll(selector)); }
  function clean(value, max){ return String(value == null ? '' : value).replace(/[<>\u0000-\u001F\u007F]/g,'').trim().slice(0,max || 160); }
  function safeParse(value){ try{return JSON.parse(value);}catch(_e){return null;} }
  function uniqueId(){ return 'mh_' + Date.now().toString(36) + '_' + Math.random().toString(36).slice(2,12); }
  function displaySize(value){ var raw=clean(value,80);var size=raw.toUpperCase();if(size==='ADT'||size==='ADULT'||size==='A')return 'Adult';if(size==='YTH'||size==='YOUTH'||size==='Y')return 'Youth';return raw; }

  function initMenu(){
    var button=qs(document,'[data-menu-toggle]');
    var menu=qs(document,'[data-mobile-menu]');
    if(!button||!menu)return;
    button.addEventListener('click',function(){
      var open=menu.hasAttribute('open');
      if(open){menu.removeAttribute('open');button.setAttribute('aria-expanded','false');}
      else{menu.setAttribute('open','');button.setAttribute('aria-expanded','true');}
    });
  }

  function initExperience(root){
    if(root.dataset.mhReady==='true')return;
    root.dataset.mhReady='true';
    var expectedOrigin=clean(root.dataset.expectedOrigin,200);
    var endpoint=clean(root.dataset.appEndpoint,300);
    var checkoutEnabled=root.dataset.checkoutEnabled==='true';
    var form=qs(root,'[data-mh-checkout-form]');
    var iframe=null;
    var originalValues={};
    var correctedValues={};
    var identifiers={};
    var capturedAt='';
    var builderEvent='';
    var lastCompletedReference='';
    var debugEnabled=false;
    try{debugEnabled=new URLSearchParams(window.location.search).get('mhdebug')==='1';}catch(_e){}
    var debugTrace=[];
    var debugPanel=null;
    var debugOutput=null;

    function debugDescribeData(data){
      if(typeof data==='string')return data.slice(0,2200);
      if(data==null)return String(data);
      if(typeof data!=='object')return String(data);
      var safe={};
      Object.keys(data).slice(0,40).forEach(function(key){
        var value=data[key];
        if(/email|phone|telephone|address|name/i.test(key)){safe[key]='[redacted]';return;}
        if(value&&typeof value==='object'){
          try{safe[key]=JSON.parse(JSON.stringify(value));}catch(_e){safe[key]='[object]';}
        }else safe[key]=value;
      });
      try{return JSON.stringify(safe).slice(0,4200);}catch(_e){return '[unserializable object]';}
    }
    function debugEventType(data){
      if(typeof data==='string'){
        var match=data.match(/^(cartData|asg[A-Za-z0-9_]+|reLoadIframe|scrollToTop|backToframe)/);
        return match?match[1]:'string';
      }
      if(data&&typeof data==='object')return clean(data.type||data.event||data.action||'object',100);
      return typeof data;
    }
    function renderDebugTrace(){
      if(!debugOutput)return;
      debugOutput.textContent=debugTrace.join('\n\n');
      debugOutput.scrollTop=debugOutput.scrollHeight;
    }
    function addDebugTrace(event){
      if(!debugEnabled||!event)return;
      var current=locateIframe();
      var sourceRelation=current&&event.source===current.contentWindow?'OUTER_IFRAME':'OTHER_OR_NESTED_FRAME';
      var type=debugEventType(event.data);
      var cartLike=(type==='cartData'||(typeof event.data==='string'&&event.data.indexOf('cartData')>-1));
      var line=[
        '['+new Date().toISOString()+']'+(cartLike?' *** CART/SUBMIT EVENT ***':''),
        'origin: '+(event.origin||'(empty)'),
        'source: '+sourceRelation,
        'type: '+type,
        'data: '+debugDescribeData(event.data)
      ].join('\n');
      debugTrace.push(line);
      if(debugTrace.length>80)debugTrace.shift();
      renderDebugTrace();
    }
    function initDebugPanel(){
      if(!debugEnabled||document.getElementById('mh-message-trace'))return;
      debugPanel=document.createElement('aside');
      debugPanel.id='mh-message-trace';
      debugPanel.setAttribute('aria-label','Momentec message trace');
      debugPanel.style.cssText='position:fixed;left:12px;right:12px;bottom:12px;z-index:2147483647;background:#111;color:#fff;border:2px solid #fff;border-radius:10px;box-shadow:0 8px 30px rgba(0,0,0,.35);padding:12px;font:12px/1.45 ui-monospace,SFMono-Regular,Menlo,monospace;max-height:42vh;display:flex;flex-direction:column;gap:8px';
      var head=document.createElement('div');head.style.cssText='display:flex;align-items:center;gap:8px;flex-wrap:wrap';
      var title=document.createElement('strong');title.textContent='Momentec Message Trace';title.style.cssText='font:700 14px/1.2 system-ui,sans-serif;margin-right:auto';
      var hint=document.createElement('span');hint.textContent='Click Submit Design, then copy this trace.';hint.style.cssText='font:12px/1.2 system-ui,sans-serif;color:#ddd';
      var copy=document.createElement('button');copy.type='button';copy.textContent='Copy Trace';copy.style.cssText='padding:6px 10px;border:0;border-radius:6px;cursor:pointer';
      var clear=document.createElement('button');clear.type='button';clear.textContent='Clear';clear.style.cssText='padding:6px 10px;border:0;border-radius:6px;cursor:pointer';
      var close=document.createElement('button');close.type='button';close.textContent='Hide';close.style.cssText='padding:6px 10px;border:0;border-radius:6px;cursor:pointer';
      debugOutput=document.createElement('pre');debugOutput.style.cssText='margin:0;white-space:pre-wrap;overflow:auto;background:#000;padding:10px;border-radius:6px;min-height:80px;max-height:28vh';debugOutput.textContent='Waiting for browser messages...';
      copy.addEventListener('click',function(){var text=debugTrace.join('\n\n');if(navigator.clipboard&&navigator.clipboard.writeText)navigator.clipboard.writeText(text).then(function(){copy.textContent='Copied';setTimeout(function(){copy.textContent='Copy Trace';},1200);});});
      clear.addEventListener('click',function(){debugTrace=[];debugOutput.textContent='Trace cleared. Click Submit Design again.';});
      close.addEventListener('click',function(){debugPanel.style.display='none';});
      head.appendChild(title);head.appendChild(hint);head.appendChild(copy);head.appendChild(clear);head.appendChild(close);
      debugPanel.appendChild(head);debugPanel.appendChild(debugOutput);document.body.appendChild(debugPanel);
    }

    function locateIframe(){
      var candidate=qs(root,'#myIframe');
      if(candidate)iframe=candidate;
      return iframe;
    }
    locateIframe();
    var observer=new MutationObserver(function(){ if(!iframe)locateIframe(); });
    observer.observe(root,{childList:true,subtree:true});
    initDebugPanel();

    function fieldNode(name){
      var map={builderReference:'[data-mh-builder-reference]',style:'[data-mh-style]',color:'[data-mh-color]',size:'[data-mh-size]',quantity:'[data-mh-quantity]',decorationType:'[data-mh-decoration]'};
      return qs(root,map[name]);
    }
    function summaryNode(name){
      var map={builderReference:'[data-mh-summary-reference]',style:'[data-mh-summary-style]',color:'[data-mh-summary-color]'};
      return qs(root,map[name]);
    }
    function setCaptured(name,value,source){
      value=clean(value,160);if(name==='size')value=displaySize(value);if(!value)return;
      if(!originalValues[name])originalValues[name]=value;
      var input=fieldNode(name);
      if(input && !correctedValues[name]){input.value=value;input.readOnly=(name==='builderReference'||name==='style'||name==='color');clearFieldIssue(name);}
      var status=qs(root,'[data-mh-field-status="'+name+'"]');
      if(status){status.textContent='Captured from builder';status.classList.add('is-captured');}
      var summary=summaryNode(name);if(summary)summary.textContent=value;
      if(source)root.dataset['source'+name.charAt(0).toUpperCase()+name.slice(1)]=source;
      updateProgress();
    }
    function setIdentifier(key,value){value=clean(value,120);if(value)identifiers[key]=value;}
    function captureReference(value,source){
      value=clean(value,80).toUpperCase();
      if(!/^C[A-Z0-9-]{3,79}$/.test(value))return '';
      setIdentifier(source||'asgSNumber',value);
      setCaptured('builderReference',value,source||'asgSNumber');
      capturedAt=new Date().toISOString();builderEvent=source||'asgSNumber';
      showCaptureToast(value);
      return value;
    }
    function parseIframeUrl(text){
      var raw=clean(text,2000);if(!raw)return;
      var urlText=raw.indexOf('asgIframeSrc|')===0?raw.slice('asgIframeSrc|'.length):raw;
      try{
        var url=new URL(urlText);
        var style=url.searchParams.get('partNumber')||url.searchParams.get('styleId');
        var color=url.searchParams.get('capColorCode')||url.searchParams.get('color');
        var sNumber=url.searchParams.get('sNumber');
        var dNumber=url.searchParams.get('dNumber');
        var webRef=url.searchParams.get('webRef');
        if(style)setCaptured('style',style,'iframe.partNumber');
        if(color)setCaptured('color',color,'iframe.capColorCode');
        if(sNumber)setIdentifier('sNumber',sNumber);
        if(dNumber)setIdentifier('dNumber',dNumber);
        if(webRef)setIdentifier('webRef',webRef);
      }catch(_e){}
    }
    function parseCartPayload(payload,isStringMessage){
      var candidate=payload;
      if(isStringMessage&&typeof candidate==='string'){
        var hashIndex=candidate.indexOf('#');
        candidate=hashIndex>-1?candidate.slice(hashIndex+1):candidate.replace(/^cartData[:|]?/i,'');
        var parsed=safeParse(candidate);
        if(!parsed){try{parsed=safeParse(decodeURIComponent(candidate));}catch(_e){parsed=null;}}
        if(parsed)candidate=parsed;
      }
      if(Array.isArray(candidate)){
        candidate.slice(0,20).forEach(function(item){if(item&&typeof item==='object')parseObject(item);});
        return;
      }
      if(candidate&&typeof candidate==='object'){
        parseObject(candidate);
        ['design','product','item','selection','cartItem'].forEach(function(key){if(candidate[key]&&typeof candidate[key]==='object')parseObject(candidate[key]);});
        ['items','cartItems','lineItems'].forEach(function(key){if(Array.isArray(candidate[key]))candidate[key].slice(0,20).forEach(function(item){if(item&&typeof item==='object')parseObject(item);});});
      }
    }
    function parseString(message){
      if(message.length>65536)return;
      if(message.indexOf('asgIframeSrc|')===0){parseIframeUrl(message);return;}
      if(message.indexOf('asgSNumber:')===0){
        var submittedReference=captureReference(message.slice('asgSNumber:'.length),'asgSNumber');
        if(submittedReference&&checkoutEnabled&&form&&endpoint)finishBuilderHandoff('asgSNumber');
        return;
      }
      if(message.indexOf('cartData')===0){parseCartPayload(message,true);return;}
      if(message.indexOf('asgOrderTotal:')===0)return;
      if(message.indexOf('asgIframeHeight:')===0)return;
    }
    function pick(obj,keys){for(var i=0;i<keys.length;i++){var key=keys[i];if(obj&&Object.prototype.hasOwnProperty.call(obj,key)&&obj[key]!=null)return obj[key];}return '';}
    function parseObject(data){
      if(!data||Array.isArray(data))return;
      var raw='';try{raw=JSON.stringify(data);}catch(_e){return;}if(raw.length>65536)return;
      var payload=(data.payload&&typeof data.payload==='object'&&!Array.isArray(data.payload))?data.payload:data;
      var ref=pick(payload,['asgSNumber','referenceNumber','builderReference']);
      if(ref)captureReference(ref,Object.prototype.hasOwnProperty.call(payload,'asgSNumber')?'asgSNumber':'referenceNumber');
      ['referenceNumber','asgSNumber','sNumber','dNumber','rNumber','webRef','configurationId','designNumber'].forEach(function(key){if(payload[key]!=null)setIdentifier(key,payload[key]);});
      var style=pick(payload,['styleName','style','styleId','productNumber','partNumber']);if(style)setCaptured('style',style,'object.style');
      var color=pick(payload,['colorName','color','capColorCode','colorCode']);if(color)setCaptured('color',color,'object.color');
      var size=pick(payload,['sizeName','size','sizeCode']);if(size)setCaptured('size',size,'object.size');
      var qty=pick(payload,['quantity','qty','orderQty']);if(qty)setCaptured('quantity',qty,'object.quantity');
      var decoration=pick(payload,['decorationType','decoration','method']);if(decoration)setCaptured('decorationType',decoration,'object.decoration');
      if(data.type==='DETAILS_PAGE'||data.type==='PRODUCT_SPECIFIC_PAGE'||data.type==='DESIGN_VIEW'){
        if(data.styleId)setCaptured('style',data.styleId,'event.styleId');
        if(data.webRef)setIdentifier('webRef',data.webRef);
        if(data.designid)setIdentifier('dNumber',data.designid);
      }
    }
    function isTrustedBuilderEvent(event){
      var current=locateIframe();
      return !!(event&&expectedOrigin&&event.origin===expectedOrigin&&current&&event.source===current.contentWindow);
    }
    function missingCapturedFields(){
      var missing=[];
      ['builderReference','style','color'].forEach(function(name){var input=fieldNode(name);if(!input||!clean(input.value,160))missing.push(name);});
      return missing;
    }
    function markFieldIssue(name,message){
      var input=fieldNode(name);if(!input)return;
      var wrap=input.closest('[data-mh-capture-field]')||input.closest('.mh-field');if(wrap)wrap.classList.add('is-missing');
      var status=qs(root,'[data-mh-field-status="'+name+'"]');if(status){status.textContent=message||'Required before checkout';status.classList.remove('is-captured');}
    }
    function clearFieldIssue(name){var input=fieldNode(name);if(!input)return;var wrap=input.closest('[data-mh-capture-field]')||input.closest('.mh-field');if(wrap)wrap.classList.remove('is-missing');}
    function finishBuilderHandoff(trigger){
      capturedAt=capturedAt||new Date().toISOString();
      builderEvent=builderEvent||trigger||'builderSubmit';
      updateProgress(true);
      var ref=fieldNode('builderReference');
      var reference=ref?clean(ref.value,80):'';
      var firstCompletion=!reference||reference!==lastCompletedReference;
      if(reference){lastCompletedReference=reference;showCaptureToast(reference);}
      var missing=missingCapturedFields();
      missing.forEach(function(name){markFieldIssue(name,'Not provided by builder. Please confirm.');});
      if(missing.length){showStatus('Design saved. Please confirm the missing builder details below.','missing');}
      else{showStatus('Design details captured. Confirm quantity, decoration, and contact details to continue.','success');}
      var confirm=qs(root,'#confirm-design');
      try{
        window.dispatchEvent(new CustomEvent('momentec:handoff',{detail:{trigger:trigger||'builderSubmit',reference:reference||'',missing:missing.slice()}}));
      }catch(_e){}
      if(confirm&&firstCompletion){
        requestAnimationFrame(function(){
          confirm.scrollIntoView({behavior:'smooth',block:'start'});
          setTimeout(function(){
            var rect=confirm.getBoundingClientRect();
            if(Math.abs(rect.top)>140){
              var top=Math.max(0,window.pageYOffset+rect.top-24);
              window.scrollTo({top:top,behavior:'smooth'});
            }
          },350);
        });
      }
    }
    window.MomentecHatsBridge=window.MomentecHatsBridge||{};
    window.MomentecHatsBridge.handleCartData=function(event,payload,isStringMessage){
      if(!checkoutEnabled||!form||!endpoint||!isTrustedBuilderEvent(event))return false;
      parseCartPayload(payload,!!isStringMessage);finishBuilderHandoff('cartData');return true;
    };
    window.addEventListener('message',function(event){
      addDebugTrace(event);
      if(!isTrustedBuilderEvent(event))return;
      if(typeof event.data==='string')parseString(event.data);
      else if(event.data&&typeof event.data==='object')parseObject(event.data);
    });
    window.MomentecHatsBridge.version='2.0.4';
    window.MomentecHatsBridge.initialized=true;
    root.dataset.mhBridgeVersion='2.0.4';
    root.dataset.mhBridgeInitialized='true';

    qsa(root,'[data-mh-edit-field]').forEach(function(button){
      button.addEventListener('click',function(){
        var name=button.dataset.mhEditField;var input=fieldNode(name);if(!input)return;
        input.readOnly=false;input.focus();input.select();
        input.addEventListener('input',function(){correctedValues[name]=clean(input.value,160);clearFieldIssue(name);},{once:false});
        var status=qs(root,'[data-mh-field-status="'+name+'"]');if(status){status.textContent='Customer correction';status.classList.remove('is-captured');}
      });
    });
    var scrollButton=qs(root,'[data-mh-scroll-confirm]');if(scrollButton)scrollButton.addEventListener('click',function(){qs(root,'#confirm-design').scrollIntoView({behavior:'smooth',block:'start'});});

    var decoration=qs(root,'[data-mh-decoration]');
    var quantity=qs(root,'[data-mh-quantity]');
    function minimumFor(type){if(type==='Embroidery')return parseInt(root.dataset.minEmbroidery||'12',10);if(type==='Leather Patch')return parseInt(root.dataset.minLeather||'24',10);return parseInt(root.dataset.minOther||'48',10);}
    function updateMinimum(){
      var note=qs(root,'[data-mh-minimum-note]');
      if(!decoration||!decoration.value){if(note)note.textContent='Choose a decoration type to see the minimum.';return 0;}
      var min=minimumFor(decoration.value);if(quantity)quantity.min=String(min);if(note)note.textContent=decoration.value+' requires at least '+min+' hats per design.';return min;
    }
    if(decoration)decoration.addEventListener('change',updateMinimum);updateMinimum();

    function showCaptureToast(reference){
      var toast=qs(root,'[data-mh-capture-toast]');var text=qs(root,'[data-mh-capture-toast-text]');
      if(text)text.textContent='Design '+reference+' is ready to confirm.';
      if(toast)toast.hidden=false;
      updateProgress(true);
    }
    function updateProgress(saved){
      var design=qs(root,'[data-mh-step="design"]');var confirm=qs(root,'[data-mh-step="confirm"]');
      if(saved||fieldNode('builderReference').value){if(design){design.classList.remove('is-active');design.classList.add('is-complete');}if(confirm)confirm.classList.add('is-active');}
    }
    function value(selector){var el=qs(root,selector);return el?clean(el.value,2000):'';}
    function showStatus(message,state){var el=qs(root,'[data-mh-checkout-status]');if(!el)return;el.hidden=false;el.textContent=message;el.dataset.state=state||'';}
    function setBusy(busy){var btn=qs(root,'[data-mh-checkout-button]');if(!btn)return;if(!btn.dataset.originalLabel)btn.dataset.originalLabel=btn.textContent;btn.disabled=busy;btn.setAttribute('aria-busy',busy?'true':'false');btn.textContent=busy?'Preparing secure checkout...':btn.dataset.originalLabel;}
    function responseJson(response){return response.text().then(function(text){var data=safeParse(text);if(!data)throw new Error('Secure checkout returned an unreadable response. Please try again.');return {ok:response.ok,data:data};});}
    function checkoutError(data,fallback){var err=new Error((data&&data.message)||fallback||'Unable to prepare checkout.');err.code=data&&data.code||'';err.field=data&&data.field||'';err.httpStatus=data&&data.httpStatus||0;return err;}
    function focusIssue(error){if(!error||!error.field)return;markFieldIssue(error.field,error.message);var input=fieldNode(error.field);if(input){if(input.readOnly){var button=qs(root,'[data-mh-edit-field="'+error.field+'"]');if(button)button.focus();else input.focus();}else input.focus();}}
    function startCheckout(payload,retryCount){
      showStatus(retryCount?'Refreshing your secure checkout session...':'Validating the design, price, and checkout details...',retryCount?'expired':'loading');
      return fetch(endpoint,{method:'GET',headers:{'Accept':'application/json'},credentials:'same-origin'})
        .then(responseJson)
        .then(function(result){if(!result.ok||!result.data||!result.data.handoffToken)throw checkoutError(result.data,'Unable to start secure checkout.');payload.handoffToken=result.data.handoffToken;return fetch(endpoint,{method:'POST',headers:{'Content-Type':'application/json','Accept':'application/json'},credentials:'same-origin',body:JSON.stringify(payload)});})
        .then(responseJson)
        .then(function(result){
          var data=result.data||{};
          if((!result.ok||data.success===false)&&data.code==='HANDOFF_EXPIRED'&&retryCount<1)return startCheckout(payload,retryCount+1);
          if(!result.ok||!data.success)throw checkoutError(data,'Unable to prepare checkout.');
          return data;
        });
    }
    if(form)form.addEventListener('submit',function(event){
      event.preventDefault();
      if(!checkoutEnabled){showStatus('Secure checkout is temporarily unavailable. Please contact us for help.','error');return;}
      var referenceInput=fieldNode('builderReference');var styleInput=fieldNode('style');var colorInput=fieldNode('color');
      if(!referenceInput||!clean(referenceInput.value,80)){showStatus('Finish and save your design in the builder before continuing.','error');qs(root,'#builder-stage').scrollIntoView({behavior:'smooth',block:'start'});return;}
      if(!styleInput||!clean(styleInput.value,80)){showStatus('We could not capture the style. Select Correct beside Style and enter the style shown in the builder.','error');if(styleInput)styleInput.focus();return;}
      if(!colorInput||!clean(colorInput.value,120)){showStatus('We could not capture the color. Select Correct beside Color and enter the color or Momentec color code.','error');if(colorInput)colorInput.focus();return;}
      var min=updateMinimum();var qty=parseInt(quantity&&quantity.value?quantity.value:'0',10);
      if(!decoration||!decoration.value){decoration.setCustomValidity('Choose a decoration type.');decoration.reportValidity();return;}decoration.setCustomValidity('');
      if(!Number.isInteger(qty)||qty<min){quantity.setCustomValidity('Enter at least '+min+' hats.');quantity.reportValidity();return;}quantity.setCustomValidity('');
      if(!form.reportValidity())return;
      var endpointUrl;try{endpointUrl=new URL(endpoint,window.location.origin);}catch(_e){showStatus('Checkout is not configured correctly.','error');return;}
      if(endpointUrl.origin!==window.location.origin){showStatus('Checkout must use the secure store connection.','error');return;}
      endpoint=endpointUrl.pathname+endpointUrl.search;
      var payload={
        schemaVersion:'2.0',clientRequestId:uniqueId(),builderReference:value('[data-mh-builder-reference]'),builderEvent:builderEvent,capturedAt:capturedAt,
        identifiers:identifiers,originalValues:originalValues,correctedValues:correctedValues,style:value('[data-mh-style]'),color:value('[data-mh-color]'),size:value('[data-mh-size]'),quantity:qty,
        decorationType:decoration.value,customerName:value('[data-mh-customer-name]'),company:value('[data-mh-company]'),email:value('[data-mh-email]'),telephone:value('[data-mh-telephone]'),specialInstructions:value('[data-mh-instructions]'),consent:!!qs(root,'[data-mh-consent]:checked')
      };
      setBusy(true);
      startCheckout(payload,0)
        .then(function(data){
          var total=qs(root,'[data-mh-checkout-total]');
          if(data.unitPrice){qs(root,'[data-mh-unit-price]').textContent=data.currencySymbol?data.currencySymbol+data.unitPrice:data.unitPrice;}
          if(data.merchandiseTotal){qs(root,'[data-mh-merchandise-total]').textContent=data.currencySymbol?data.currencySymbol+data.merchandiseTotal:data.merchandiseTotal;}
          if(total)total.hidden=false;
          if(!data.checkoutUrl)throw new Error('Shopify checkout link was not returned.');
          var step=qs(root,'[data-mh-step="checkout"]');if(step)step.classList.add('is-active');
          showStatus(data.duplicate?'We found your existing secure checkout. Redirecting now...':'Price verified. Redirecting to secure Shopify checkout...',data.duplicate?'duplicate':'success');
          window.location.assign(data.checkoutUrl);
        })
        .catch(function(error){
          focusIssue(error);
          if(error&&error.code==='HANDOFF_EXPIRED')showStatus('Your secure checkout session expired. Please select the checkout button again.','expired');
          else if(error&&error.code==='INSUFFICIENT_INVENTORY')showStatus(error.message,'inventory');
          else showStatus(error.message||'Unable to prepare checkout. Please try again.','error');
          setBusy(false);
        });
    });
  }

  function initPopup(root){
    if(root.dataset.enabled!=='true')return;
    if(window.innerWidth<700&&root.dataset.mobileEnabled!=='true')return;
    var delay=Math.max(1,parseInt(root.dataset.delay||'8',10))*1000;var shown=false;
    function show(){if(shown)return;shown=true;root.hidden=false;var close=qs(root,'[data-popup-close]');if(close)close.focus();}
    setTimeout(show,delay);root.addEventListener('click',function(event){if(event.target===root||event.target.closest('[data-popup-close]'))root.hidden=true;});
  }

  function initPage(root){
    initMenu();qsa(root||document,'[data-mh-experience]').forEach(initExperience);qsa(root||document,'[data-mh-popup]').forEach(initPopup);
  }
  function boot(){initPage(document);}
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',boot,{once:true});
  else boot();
  document.addEventListener('shopify:section:load',function(event){initPage(event.target);});
})();
